import React from "react"

const debug = false
// const debug = "FieldDateRange_InlineValueNotEmpty"

export default function FieldDateRange_InlineValueNotEmpty(props:any) {

    const showIcon = _.get(props.configOptions, 'showIcon', true)

    debug && console.log(debug, 'render', showIcon, props)

    const onDeleteClick = () => {
        props.onChange(null);
    }

    return (
        <React.Fragment>
            <div className={Classes("ui5-field-with-delete-on-hover", props.className)}>
                <div className="ui5-field-dropdown-inline-editable with-delete txt-truncate" onClick={props.onClick}>
                    {showIcon && _.get(props.field.components, 'ValueIcon', false)}
                    <div className="txt-truncate">
                        {props.field.getDisplayValue(props.value)}
                    </div>
                </div>

                {props.field.clearButton && <div className="ui5-ico-trash red s-14" onClick={onDeleteClick}/>}
            </div>

            {props.children}
        </React.Fragment>
    )
}